import { useGetLoggedInUser } from '@upright/ui/common/generic/hooks';
import { KBUrl } from '@upright/ui/common/upright/kb-urls';
import { useLocation } from 'react-router';
import styled from 'styled-components';
import { ExternalLink, Item, ItemLink, MenuTitleSmall } from '../../shared-menus';

export function LearnMoreBlock() {
  const user = useGetLoggedInUser();
  const location = useLocation();
  const isNotLoggedInAndNotOnHomePage = !user && location.pathname !== '/';
  return (
    <Root>
      <MenuTitleSmall>Learn more</MenuTitleSmall>
      {isNotLoggedInAndNotOnHomePage && (
        <Item>
          <ItemLink to="/">Home</ItemLink>
        </Item>
      )}
      <Item>
        <ExternalLink href={KBUrl.INDEX} target="_blank">
          Knowledge base
        </ExternalLink>
      </Item>
    </Root>
  );
}

const Root = styled.div``;
